import { SpecialistDashboardComponent } from './specialist-dashboard/specialist-dashboard.component';
import { PatientDashboardComponent } from './patient-dashboard/patient-dashboard.component';

import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';

import { PostsService } from './services/posts.service';
import { DashboardComponent } from './dashboard/dashboard.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatDialogModule, MatIconModule, MatButtonModule, MatRadioModule, MatProgressSpinnerModule } from '@angular/material';
import { MaterialModule } from '../material-module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { SharedModule } from '../shared/models/shared.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { AdminMenuComponent } from '../menu/admin-menu/admin-menu.component';
import { TopToolbarComponent } from '../toolbar/top-toolbar/top-toolbar.component';
import { FooterComponent } from '../toolbar/footer/footer.component';
import { NotificationModule } from '../notification/notification.module';
import { ComponentsModule } from '../shared/components/components.module';
import { AppTransModule } from '../app-trans/app-trans.module';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';







@NgModule({
  declarations: [ DashboardComponent    
    , AdminDashboardComponent ,PatientDashboardComponent,SpecialistDashboardComponent] ,
  imports: [
    CommonModule,
    DashboardRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    SatPopoverModule,
    SharedModule, ToolbarModule , MatProgressSpinnerModule,NotificationModule ,ComponentsModule ,
    AppTransModule,


  ] ,
  schemas: [
   
  ],
  providers : [
   PostsService

  ],
  exports:[SpecialistDashboardComponent,PatientDashboardComponent,AdminDashboardComponent]
  
})
export class DashboardModule { }
